'use client';

export const HeaderRedesign = () => {
  return (
    <>
      <p>New header navigation</p>
      <p>welcome</p>
    </>
  );
};
